const iconAddWishlist_list_svg =
`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M8.88895 0V7.11105H16V8.88895H8.88895V16H7.11105V8.88895H9.53674e-07V7.11105H7.11105V0H8.88895Z" fill="black"/>
</svg>`;
const iconEditWishlist_list_svg =`<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
<path d="M3.93357 21.1743C3.72985 21.1743 3.53426 21.0947 3.38848 20.9523C3.24269 20.8099 3.15838 20.6163 3.15362 20.4125L3.07051 16.6398C3.06575 16.4268 3.14847 16.2211 3.29922 16.0705L16.1692 3.20053C16.3154 3.05454 16.5136 2.97241 16.7203 2.97241C16.927 2.97241 17.1254 3.05454 17.2715 3.20053L20.948 6.89248C21.094 7.03867 21.1761 7.23704 21.1761 7.44371C21.1761 7.65041 21.094 7.84858 20.948 7.99494L8.07799 20.8649V20.8647C7.93636 21.0068 7.74553 21.0887 7.54499 21.0937L3.95181 21.1768L3.93357 21.1743ZM4.63557 16.9519L4.69528 19.5987L7.19646 19.5415L19.2915 7.44392L16.7175 4.86992L4.63557 16.9519Z" fill="black"/>
<path d="M8.86337 19.7184C8.66084 19.719 8.46605 19.6407 8.32007 19.5L4.68007 15.86C4.4946 15.6609 4.42616 15.3796 4.49975 15.1175C4.57315 14.8555 4.77806 14.6508 5.03991 14.5772C5.30195 14.5038 5.58342 14.572 5.78238 14.7575L9.42238 18.3975V18.3977C9.56858 18.5439 9.6507 18.7423 9.6505 18.9489C9.6505 19.1556 9.56838 19.3538 9.42238 19.5002C9.27619 19.6463 9.07803 19.7287 8.87131 19.7287L8.86337 19.7184Z" fill="black"/>
<path d="M17.8332 10.7483C17.6265 10.7481 17.4281 10.6658 17.2821 10.5196L13.6421 6.87963H13.6419C13.4564 6.68048 13.3882 6.3992 13.4616 6.13716C13.5352 5.87512 13.7399 5.67041 14.0019 5.5968C14.264 5.52321 14.5453 5.59164 14.7444 5.77711L18.3844 9.41711C18.5304 9.5635 18.6125 9.76167 18.6125 9.96834C18.6125 10.1752 18.5304 10.3734 18.3842 10.5196C18.2382 10.666 18.0399 10.7481 17.8331 10.7483L17.8332 10.7483Z" fill="black"/>
</svg>`;

const svg_delete = `
<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2535 20.8158H8.74666L8.25254 7.18152L6.73682 7.23607L7.28271 22.3344H18.7176L19.2635 7.23607L17.7478 7.18152L17.2535 20.8158Z" fill="black"/><path d="M11.1049 18.6158V9.41428C11.1049 9.14311 10.9601 8.8924 10.7252 8.75691C10.4904 8.62123 10.201 8.62123 9.9661 8.75691C9.73123 8.8924 9.58643 9.14313 9.58643 9.41428V18.6158C9.58643 18.887 9.73123 19.1375 9.9661 19.2732C10.201 19.4089 10.4904 19.4089 10.7252 19.2732C10.9601 19.1375 11.1049 18.887 11.1049 18.6158Z" fill="black"/><path d="M13.759 18.6158V9.41428C13.759 9.14311 13.6144 8.8924 13.3795 8.75691C13.1445 8.62123 12.8553 8.62123 12.6202 8.75691C12.3853 8.8924 12.2407 9.14313 12.2407 9.41428V18.6158C12.2407 18.887 12.3853 19.1375 12.6202 19.2732C12.8553 19.4089 13.1445 19.4089 13.3795 19.2732C13.6144 19.1375 13.759 18.887 13.759 18.6158Z" fill="black"/><path d="M16.414 18.6158V9.41428C16.414 9.14311 16.2692 8.8924 16.0343 8.75691C15.7994 8.62123 15.51 8.62123 15.2752 8.75691C15.0403 8.8924 14.8955 9.14313 14.8955 9.41428V18.6158C14.8955 18.887 15.0403 19.1375 15.2752 19.2732C15.51 19.4089 15.7994 19.4089 16.0343 19.2732C16.2692 19.1375 16.414 18.887 16.414 18.6158Z" fill="black"/><path d="M16.3619 5.20003V4.71642C16.3611 4.25146 16.1758 3.80571 15.8469 3.47726C15.5178 3.14876 15.0717 2.96411 14.6068 2.96411H11.3933C10.9283 2.96411 10.4822 3.14879 10.1531 3.47726C9.8242 3.80575 9.63893 4.25147 9.63812 4.71642V5.20003H4.99463V6.71849H21.0054V5.20003H16.3619ZM11.1619 4.71384H11.1617C11.1617 4.65135 11.1867 4.59145 11.2311 4.54761C11.2756 4.50358 11.3359 4.47917 11.3984 4.47997H14.6067C14.6692 4.47918 14.7295 4.50358 14.7739 4.54761C14.8184 4.59145 14.8434 4.65136 14.8434 4.71384V5.20003H11.1566L11.1619 4.71384Z" fill="black"/></svg>
`;

const iconDeleteWishlist_list_svg = `url("data:image/svg+xml,${encodeURIComponent(svg_delete)}")`;

//const iconDeleteWishlist_list_svg =`url('data:image/svg+xml,<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2535 20.8158H8.74666L8.25254 7.18152L6.73682 7.23607L7.28271 22.3344H18.7176L19.2635 7.23607L17.7478 7.18152L17.2535 20.8158Z" fill="black"/><path d="M11.1049 18.6158V9.41428C11.1049 9.14311 10.9601 8.8924 10.7252 8.75691C10.4904 8.62123 10.201 8.62123 9.9661 8.75691C9.73123 8.8924 9.58643 9.14313 9.58643 9.41428V18.6158C9.58643 18.887 9.73123 19.1375 9.9661 19.2732C10.201 19.4089 10.4904 19.4089 10.7252 19.2732C10.9601 19.1375 11.1049 18.887 11.1049 18.6158Z" fill="black"/><path d="M13.759 18.6158V9.41428C13.759 9.14311 13.6144 8.8924 13.3795 8.75691C13.1445 8.62123 12.8553 8.62123 12.6202 8.75691C12.3853 8.8924 12.2407 9.14313 12.2407 9.41428V18.6158C12.2407 18.887 12.3853 19.1375 12.6202 19.2732C12.8553 19.4089 13.1445 19.4089 13.3795 19.2732C13.6144 19.1375 13.759 18.887 13.759 18.6158Z" fill="black"/><path d="M16.414 18.6158V9.41428C16.414 9.14311 16.2692 8.8924 16.0343 8.75691C15.7994 8.62123 15.51 8.62123 15.2752 8.75691C15.0403 8.8924 14.8955 9.14313 14.8955 9.41428V18.6158C14.8955 18.887 15.0403 19.1375 15.2752 19.2732C15.51 19.4089 15.7994 19.4089 16.0343 19.2732C16.2692 19.1375 16.414 18.887 16.414 18.6158Z" fill="black"/><path d="M16.3619 5.20003V4.71642C16.3611 4.25146 16.1758 3.80571 15.8469 3.47726C15.5178 3.14876 15.0717 2.96411 14.6068 2.96411H11.3933C10.9283 2.96411 10.4822 3.14879 10.1531 3.47726C9.8242 3.80575 9.63893 4.25147 9.63812 4.71642V5.20003H4.99463V6.71849H21.0054V5.20003H16.3619ZM11.1619 4.71384H11.1617C11.1617 4.65135 11.1867 4.59145 11.2311 4.54761C11.2756 4.50358 11.3359 4.47917 11.3984 4.47997H14.6067C14.6692 4.47918 14.7295 4.50358 14.7739 4.54761C14.8184 4.59145 14.8434 4.65136 14.8434 4.71384V5.20003H11.1566L11.1619 4.71384Z" fill="black"/></svg>')`;
const shareIcon = `<svg class="wishlist-share-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M12.5357 1.78367C12.4812 1.75002 12.4111 1.75707 12.3663 1.80332L6.89103 7.28137C6.85322 7.31779 6.84061 7.37515 6.86027 7.42556L8.81608 12.5118C8.83712 12.565 8.88743 12.5986 8.94351 12.5986H8.94768C9.00503 12.5972 9.05545 12.5608 9.07371 12.5062L12.5948 1.94169C12.6142 1.88283 12.589 1.81704 12.5358 1.7835L12.5357 1.78367Z" fill="black"/>
<path d="M12.2164 1.46443C12.1843 1.41124 12.1184 1.38603 12.0582 1.40707L1.49233 4.92812C1.43775 4.94628 1.40133 4.9967 1.39994 5.05416C1.39855 5.11301 1.43359 5.16471 1.48678 5.18575L6.57436 7.1402C6.59113 7.14576 6.60651 7.14864 6.62339 7.14864C6.65842 7.14864 6.69335 7.13465 6.71856 7.10944L12.1966 1.63413C12.2415 1.58927 12.2499 1.5192 12.2163 1.46462L12.2164 1.46443Z" fill="black"/>
</svg>`;
const IconMoveTo = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
<path d="M8.33542 0.162771C8.5516 -0.0542571 8.90562 -0.0542571 9.12179 0.162771L12.836 3.86674C12.942 3.97092 13 4.11127 13 4.25884C13 4.40642 12.942 4.54821 12.836 4.65239L9.12179 8.35636C8.90561 8.57195 8.55159 8.57195 8.33542 8.35636C8.11779 8.13933 8.11779 7.78629 8.33542 7.57072L11.0979 4.81444H2.04284C1.53068 4.81444 1.11428 5.22968 1.11428 5.74043V9.4444C1.11428 9.75114 0.864726 10 0.557139 10C0.249552 10 0 9.75114 0 9.4444V5.74043C0 4.61476 0.914048 3.70324 2.04284 3.70324H11.0979L8.33542 0.948415C8.11779 0.731387 8.11779 0.378342 8.33542 0.162771Z" fill="black"/>
</svg>`; 


let wishlistListIconInitialized = false;
let oosAutoUpdateInitialized = false;
let wishlistUiAutoUpdateInitialized = false;

function sanitizeWishlistPrices() {
  const priceNodes = document.querySelectorAll('.card-body-container .product-price');
  priceNodes.forEach((node) => {
    if (!node) return;

    let text = node.textContent || '';
    if (!text.trim()) return;

    // Only sanitize once the app has injected a numeric price
    if (!/\d/.test(text)) return;

    text = text.replace(/price:/gi, '').replace(/AUD/gi, '').trim();
    text = text.replace(/^\$/,'').trim();
    if (!text) return;

    node.textContent = `$${text}`;
  });
}

function applyOutOfStockToDisabledAddToCartButtons() {
  // The wishlist app marks a sold-out card by setting inline
  // `pointer-events: none` (and reduced opacity) on the `.add-to-cart` wrapper.
  // We convert the label to a clear "SOLD OUT" and force a gray look.
  const disabledWrappers = document.querySelectorAll('.add-to-cart[style*="pointer-events: none"]');
  disabledWrappers.forEach((wrapper) => {
    // In many layouts the "button" is a nested element with `uc-wl`
    const buttonEl = wrapper.querySelector('.add-to-cart.uc-wl') || wrapper.querySelector('.uc-wl') || wrapper;
    if (!buttonEl) return;

    // Already converted this exact node — skip so we don't wipe/rebuild it on
    // every poll tick or DOM mutation.
    if (buttonEl.classList.contains('sold-out')) return;

    buttonEl.textContent = 'SOLD OUT';
    buttonEl.classList.add('sold-out');
    // The base `.add-to-cart.uc-wl` rule is green with `!important`, so plain
    // inline styles lose to it. Set the gray with priority so it always wins,
    // even if the stylesheet fails to load.
    buttonEl.style.setProperty('background-color', '#b3b3b3', 'important');
    buttonEl.style.setProperty('border', '1px solid #b3b3b3', 'important');
    buttonEl.style.setProperty('color', '#ffffff', 'important');
  });
}

function startOutOfStockAutoUpdate() {
  if (oosAutoUpdateInitialized) return;
  oosAutoUpdateInitialized = true;

  // Run once immediately in case elements already exist.
  applyOutOfStockToDisabledAddToCartButtons();

  let scheduled = null;
  const schedule = () => {
    if (scheduled) clearTimeout(scheduled);
    // Debounce rapid DOM updates from the wishlist app.
    scheduled = setTimeout(() => {
      applyOutOfStockToDisabledAddToCartButtons();
      scheduled = null;
    }, 150);
  };

  // Poll for a limited time in case the wishlist UI is injected after delays.
  const pollInterval = setInterval(() => {
    applyOutOfStockToDisabledAddToCartButtons();
  }, 600);

  // Also observe DOM changes and re-apply when the wishlist app injects content
  // late. `attributes`/`attributeFilter: ['style']` is essential: the app flags
  // a sold-out card by mutating the wrapper's inline `style` (adding
  // `pointer-events: none`), which a childList-only observer would miss.
  const observer = new MutationObserver(() => {
    schedule();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  // Stop the interval polling after a reasonable window, but keep the observer
  // alive: the wishlist re-renders cards on add/remove/move actions long after
  // load, and the callback is cheap and debounced.
  setTimeout(() => {
    clearInterval(pollInterval);
  }, 20000);
}

function startWishlistUiAutoUpdate() {
  if (wishlistUiAutoUpdateInitialized) return;
  wishlistUiAutoUpdateInitialized = true;

  // Run once immediately.
  replaceWishlistListIcon();
  applyOutOfStockToDisabledAddToCartButtons();

  let scheduled = null;
  const schedule = () => {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(() => {
      replaceWishlistListIcon();
      applyOutOfStockToDisabledAddToCartButtons();
      scheduled = null;
    }, 150);
  };

  // Poll for a limited time in case wishlist UI is injected after delays.
  const pollInterval = setInterval(() => {
    replaceWishlistListIcon();
    applyOutOfStockToDisabledAddToCartButtons();
  }, 800);

  // Observe DOM changes and re-apply when the wishlist app injects content late.
  // Watch `style` attributes too, so cards dimmed to sold-out (inline
  // `pointer-events: none`) re-trigger the gray styling.
  const observer = new MutationObserver(() => {
    schedule();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  // Safety: stop the interval polling after a reasonable window.
  setTimeout(() => {
    clearInterval(pollInterval);
  }, 25000);
}

function replaceWishlistListIcon() {
  const btnCreate = document.querySelector('.container__create-wishlist button');
  const btnEdit = document.querySelector('.container__wishlist-action-edit button');
  const btnDeleteImg = document.querySelector('.container__wishlist-action-delete img:not([data-icon-replaced])');
  const btnShare = document.querySelector('.share-button');
  if (btnCreate) {
    btnCreate.innerHTML = iconAddWishlist_list_svg;
  }
  if (btnEdit) {
    btnEdit.innerHTML = iconEditWishlist_list_svg;
  }
  if (btnDeleteImg) {
    // Replace the broken src with a 1×1 transparent GIF (no network request,
    // no broken-image error). Because the image content is fully transparent the
    // background-image renders through it, so the icon stays visible.
    // The <img> itself stays in the DOM so the wishlist app's click handler is preserved.
    btnDeleteImg.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
    btnDeleteImg.setAttribute('alt', '');
    btnDeleteImg.setAttribute('data-icon-replaced', 'true');
    const s = /** @type {HTMLElement} */ (btnDeleteImg).style;
    s.backgroundImage    = iconDeleteWishlist_list_svg;
    s.backgroundRepeat   = 'no-repeat';
    s.backgroundPosition = 'center';
    // s.backgroundSize     = 'contain';
    s.display            = 'inline-block';
  }
  if (btnShare && !btnShare.querySelector('.wishlist-share-icon')) {
    btnShare.innerHTML = `${shareIcon} ${btnShare.innerHTML}`;
  }

  const moveToNodes = document.querySelectorAll('.card-function .move-to');
  moveToNodes.forEach((node) => {
    if (!node) return;
    node.innerHTML = `${IconMoveTo} Move To`;
  });

  sanitizeWishlistPrices();
  applyOutOfStockToDisabledAddToCartButtons();

  if (btnCreate || btnEdit || btnDeleteImg || btnShare) {
    wishlistListIconInitialized = true;
  }
}

// Fallback: if the app has already rendered by DOMContentLoaded
document.addEventListener('DOMContentLoaded', replaceWishlistListIcon);
document.addEventListener('DOMContentLoaded', startOutOfStockAutoUpdate);
document.addEventListener('DOMContentLoaded', startWishlistUiAutoUpdate);
window.addEventListener('load', startOutOfStockAutoUpdate);
window.addEventListener('load', startWishlistUiAutoUpdate);

// Main hook: when the app fires its ready event
document.body.addEventListener('initTheWishlist', () => {
  // Poll until the wishlist UI elements exist, with a longer safety timeout.
  const hasWishlistUi = () => (
    document.querySelector('.container__create-wishlist button')
    || document.querySelector('.container__wishlist-action-edit button')
    || document.querySelector('.container__wishlist-action-delete img')
    || document.querySelector('.share-button')
    || document.querySelector('.card-function .move-to')
  );

  const interval = setInterval(() => {
    replaceWishlistListIcon();
    applyOutOfStockToDisabledAddToCartButtons();
    if (hasWishlistUi()) clearInterval(interval);
  }, 800);

  // safety timeout (in case initTheWishlist fires but UI injection is delayed)
  setTimeout(() => clearInterval(interval), 20000);
});

// Re-apply icons, prices, and "Move To" when switching wishlist tabs
document.addEventListener('click', (event) => {
  const tabButton = event.target.closest('.btn-wishlist.wishlist-item');
  const tabSpan = event.target.closest('.wishlist-tab span');
  if (!tabButton && !tabSpan) return;

  const start = Date.now();
  const duration = 3000; // run for 3 seconds after the click

  const interval = setInterval(() => {
    replaceWishlistListIcon();
    if (Date.now() - start > duration) {
      clearInterval(interval);
    }
  }, 1000);
});


/**
 * Matches theme ProductForm + CartDrawer: cart.js + bundled section HTML, then
 * cart:change (updates drawer + cart count) and variant:add (opens drawer).
 */
const WISHLIST_CART_SYNC_FETCH = {
  credentials: "same-origin",
  cache: "no-store",
};

function getCartDrawerSectionId() {
  const cartDrawer = document.getElementById("cart-drawer");
  if (!cartDrawer) return null;
  let section = cartDrawer.closest(".shopify-section");
  if (!section?.id) {
    section = cartDrawer.closest("[id^='shopify-section-']");
  }
  if (!section?.id) return null;
  return section.id.replace(/^shopify-section-/, "");
}

function dispatchCartChangeAndVariantAdd(cartJson, items) {
  document.dispatchEvent(
    new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "wishlist:add",
        cart: cartJson,
      },
    })
  );
  document.dispatchEvent(
    new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items,
        cart: cartJson,
      },
    })
  );
}

function openCartDrawerIfDrawerMode() {
  const cartDrawer = document.getElementById("cart-drawer");
  if (
    !cartDrawer ||
    window.themeVariables?.settings?.cartType !== "drawer" ||
    typeof cartDrawer.show !== "function"
  ) {
    return;
  }
  try {
    if (!cartDrawer.hasAttribute("open")) {
      cartDrawer.show();
    }
  } catch (e) {
    // ignore
  }
}

async function waitForCartDrawerElement(maxMs) {
  const deadline = Date.now() + maxMs;
  while (Date.now() < deadline) {
    const el = document.getElementById("cart-drawer");
    if (el) {
      if (window.customElements?.whenDefined) {
        try {
          await Promise.race([
            customElements.whenDefined("cart-drawer"),
            new Promise((r) => setTimeout(r, maxMs)),
          ]);
        } catch (e) {
          // ignore
        }
      }
      return el;
    }
    await new Promise((r) => setTimeout(r, 50));
  }
  return document.getElementById("cart-drawer");
}

async function syncThemeCartAfterWishlistAdd(eventDetail) {
  const root = window.Shopify?.routes?.root;
  if (!root) return;

  const settings = window.themeVariables?.settings;
  if (settings?.cartType === "page" || settings?.pageType === "cart") {
    if (settings?.pageType === "cart") {
      window.location.reload();
    } else {
      window.location.href = `${root}cart`;
    }
    return;
  }

  if (settings?.cartType !== "drawer") {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  } else {
    const cartDrawer = await waitForCartDrawerElement(2500);
    const sectionId = getCartDrawerSectionId();

    if (!sectionId || !cartDrawer) {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: { items: [], cart: { sections: {} } },
          })
        );
        openCartDrawerIfDrawerMode();
      }, 500);
    } else {
      try {
        const [cartJson, sectionHtml] = await Promise.all([
          fetch(`${root}cart.js`, WISHLIST_CART_SYNC_FETCH).then((r) =>
            r.json()
          ),
          fetch(
            `${root}?section_id=${encodeURIComponent(sectionId)}`,
            WISHLIST_CART_SYNC_FETCH
          ).then((r) => r.text()),
        ]);

        cartJson.sections = { [sectionId]: sectionHtml };

        const items = Array.isArray(eventDetail?.items)
          ? eventDetail.items
          : [];

        dispatchCartChangeAndVariantAdd(cartJson, items);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => openCartDrawerIfDrawerMode());
        });
      } catch (err) {
        console.warn("Wishlist cart drawer sync failed", err);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              bubbles: true,
              detail: { items: [], cart: { sections: {} } },
            })
          );
          openCartDrawerIfDrawerMode();
        }, 500);
      }
    }
  }

  document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
  document.documentElement.dispatchEvent(
    new CustomEvent("product:added", {
      bubbles: true,
      detail: { quantity: eventDetail?.quantity ?? 1 },
    })
  );
}

function onWishlistAddToCartEvent(e) {
  syncThemeCartAfterWishlistAdd(e.detail);
}

document.addEventListener("wishlistAddToCartEvent", onWishlistAddToCartEvent, {
  capture: true,
});